import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import benchmarkUtility from '@sparta.sales.utilities/benchmark-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { link, layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"legal-disclosure-section\">\r\n          <div class=\"disclosures\" data-nosnippet>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":12},"end":{"line":11,"column":21}}})) != null ? stack1 : "")
    + "          </div>\r\n        </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "            <p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"legal-bottom-section\" data-nosnippet>\r\n          "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerBottomSection") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":10},"end":{"line":17,"column":78}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"legal-invest-section\" data-nosnippet>\r\n          <p>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"investText") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n          <table class=\"legal-invest-table\">\r\n            <tbody>\r\n              <tr>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow1") : stack1),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":16},"end":{"line":28,"column":25}}})) != null ? stack1 : "")
    + "              </tr>\r\n              <tr>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow2") : stack1),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":16},"end":{"line":33,"column":25}}})) != null ? stack1 : "")
    + "              </tr>\r\n            </tbody>\r\n          </table>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":10},"end":{"line":41,"column":17}}})) != null ? stack1 : "")
    + "        </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                <td class=\"cell\">"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</td>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"each","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":10},"end":{"line":40,"column":19}}})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "          <p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"row collapse\">\r\n      <div class=\"column small-12\">\r\n        <div class=\"top-section"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerTopSection") : stack1)) != null ? lookupProperty(stack1,"className") : stack1),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":52,"column":31},"end":{"line":52,"column":115}}})) != null ? stack1 : "")
    + "\">\r\n          "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerTopSection") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":53,"column":10},"end":{"line":53,"column":75}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n      </div>\r\n    </div>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerTopSection") : stack1)) != null ? lookupProperty(stack1,"className") : stack1), depth0));
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":66,"column":12},"end":{"line":84,"column":19}}})) != null ? stack1 : "");
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"footerModuleLinksHelper")||(depth0 && lookupProperty(depth0,"footerModuleLinksHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),{"name":"footerModuleLinksHelper","hash":{},"data":data,"loc":{"start":{"line":68,"column":22},"end":{"line":68,"column":115}}}),{"name":"each","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":68,"column":14},"end":{"line":76,"column":23}}})) != null ? stack1 : "")
    + "            </ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"footerModuleLinksHelper")||(depth0 && lookupProperty(depth0,"footerModuleLinksHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),{"name":"footerModuleLinksHelper","hash":{},"data":data,"loc":{"start":{"line":79,"column":20},"end":{"line":79,"column":113}}}),{"name":"each","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":79,"column":12},"end":{"line":83,"column":21}}})) != null ? stack1 : "");
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ID") : depth0),"===","footer_bofa_CCPA",{"name":"compare","hash":{},"fn":container.program(19, data, 0),"inverse":container.program(24, data, 0),"data":data,"loc":{"start":{"line":69,"column":14},"end":{"line":75,"column":26}}})) != null ? stack1 : "");
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li class=\"li\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":70,"column":29},"end":{"line":70,"column":44}}})) != null ? stack1 : "")
    + "<img id=\"pillImage\" role=\"img\" loading=\"lazy\"\r\n                  src=\""
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"mode")),"==","\r\n                  auth",{"name":"compare","hash":{},"fn":container.program(20, data, 0),"inverse":container.program(22, data, 0),"data":data,"loc":{"start":{"line":71,"column":23},"end":{"line":72,"column":78}}})) != null ? stack1 : "")
    + "\" /></li>\r\n";
},"20":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0));
},"22":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icon_unauth") : depth0), depth0));
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li class=\"li\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":74,"column":29},"end":{"line":74,"column":44}}})) != null ? stack1 : "")
    + "</li>\r\n";
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"layer") : depth0),{"name":"with","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":80,"column":13},"end":{"line":82,"column":21}}})) != null ? stack1 : "");
},"27":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"layerContent","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":81,"column":12},"end":{"line":81,"column":69}}})) != null ? stack1 : "")
    + "\r\n";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "");
},"30":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"social-container \">\r\n              "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"children") : depth0),{"name":"each","hash":{},"fn":container.program(31, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":91,"column":14},"end":{"line":91,"column":53}}})) != null ? stack1 : "")
    + "\r\n            </div>\r\n";
},"31":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + " ";
},"33":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"legal\">\r\n              <p class=\"legal-text\">\r\n                <span class=\"member-fdic\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"bacFooterFDIC") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n                <span class=\"equalhousing-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"bacFooterEhl") : stack1),{"name":"if","hash":{},"fn":container.program(34, data, 0),"inverse":container.program(34, data, 0),"data":data,"loc":{"start":{"line":102,"column":18},"end":{"line":106,"column":25}}})) != null ? stack1 : "")
    + "                </span>\r\n              </p>\r\n              <p class=\"legal-text\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"globalText") : stack1)) != null ? lookupProperty(stack1,"copy") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                <span id=\"dynamic-copyright-year-update\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"globalText") : stack1)) != null ? lookupProperty(stack1,"year") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n                "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"globalText") : stack1)) != null ? lookupProperty(stack1,"boaCorp") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n                <span>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"bacFooterAllRightsReserved") : stack1),{"name":"if","hash":{},"fn":container.program(36, data, 0),"inverse":container.program(38, data, 0),"data":data,"loc":{"start":{"line":112,"column":22},"end":{"line":113,"column":68}}})) != null ? stack1 : "")
    + "</span>\r\n              </p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"bacFooterPatent") : stack1),{"name":"if","hash":{},"fn":container.program(40, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":115,"column":14},"end":{"line":119,"column":21}}})) != null ? stack1 : "")
    + "            </div>\r\n";
},"34":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                   "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"bacFooterEhl") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"36":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"bacFooterAllRightsReserved") : stack1), depth0)) != null ? stack1 : "");
},"38":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span>\r\n                    "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"globalText") : stack1)) != null ? lookupProperty(stack1,"allRightsReserved") : stack1), depth0)) != null ? stack1 : "");
},"40":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <p class=\"footer__patent-text footer-last\">\r\n                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"bacFooterPatent") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n              </p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<footer class=\"skin-cool\" role=\"contentinfo\">\r\n  <div class=\"row collapse\">\r\n    <div class=\"column small-12\">\r\n      <div class=\"legal-accordion-section\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":14,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerBottomSection") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":8},"end":{"line":19,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"section-legal-investments") : stack1),"!=",false,{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":8},"end":{"line":43,"column":20}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n  </div>\r\n  <div id=\"panel-legal\" class=\"panel-legal\" data-nosnippet>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"footerTopSection") : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":48,"column":4},"end":{"line":57,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"footer-bottom-section\">\r\n    <div class=\"row collapse\">\r\n      <div class=\"column small-12\">\r\n        <div class=\"footer-bottom clearfix\">\r\n          <div role=\"navigation\" class=\"text-center\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"section-links") : stack1),"!=",false,{"name":"compare","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":12},"end":{"line":85,"column":24}}})) != null ? stack1 : "")
    + "          </div>\r\n          <div class=\"text-center\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"social-module") : stack1),"!=",false,{"name":"compare","hash":{},"fn":container.program(30, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":89,"column":12},"end":{"line":93,"column":24}}})) != null ? stack1 : "")
    + "          </div>\r\n          <div class=\"text-center\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"section-legal-copyright") : stack1),"!=",false,{"name":"compare","hash":{},"fn":container.program(33, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":97,"column":12},"end":{"line":121,"column":24}}})) != null ? stack1 : "")
    + "          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</footer>";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

/**
 * Handlebars Helpers: Footer Module Cool Helper
 */

/**
 * {{footerModuleLinksHelper}}
 * This is a clone of footerLinksHelper in the footer-assisted-module.  TODO: sync these up.
 * Creates a final footer link object based on global links & order and a site level override.
 * @param {Object[]} globalLinkOrder [Global / default order of links]
 * @param {Object} globalLinks [Global link object (id, name, url, etc)]
 * @param {Object[]} siteLinkOrder [Site level override to specify it's footer links & which order]
 * @param {Object} siteLinks [Site level override for the link objects.
 * Anything not passed in will inherit from Globals]
 * @return {Object} [description]
 */
function footerModuleLinksHelper(globalLinkOrder, globalLinks, siteLinkOrder, siteLinks) {
  // merge site footer links over global links
  const links = Handlebars.Utils.extend(globalLinks, siteLinks);
  const finalFooterLinks = {};

  // set order of links from site or use global list
  const linkOrder = typeof siteLinkOrder === 'object' && siteLinkOrder.length > 0 ? siteLinkOrder : globalLinkOrder;

  // For each link in linkOrder, grab that link object out of links and add to finalFooterLinks
  Object.keys(linkOrder).forEach(link => {
    finalFooterLinks[link] = links[linkOrder[link]];
  });

  // return new Handlebars.SafeString(r);
  return finalFooterLinks;
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.homepage.modules/footer-module",
  "version": "1.1.5",
  "id": "footerModule",
  "containerID": "homepageFooterModule",
  "moduleName": "homepage-footer-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "footer-module",
  "data": {
    "init": "FooterModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "section-legal-disclosures",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": ""
  }, {
    "name": "section-legal-bottom",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": ""
  }, {
    "name": "section-legal-investments",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": ""
  }, {
    "name": "social-module",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Show the social module."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare,
        footerModuleLinksHelper,
        link,
        layerContent
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare,
    footerModuleLinksHelper,
    link,
    layerContent
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.sales.utilities/benchmark-utility": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.helpers/utils-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0"
  },
  "stores": []
};

/**
 * footer-module
 * module_js_id: FooterModuleJS
 */
class FooterModuleJS extends Module {
  /**
   * Getter for current URL
   * @readonly
   * @memberof FooterModuleJS
   */
  get currentURL() {
    return document.location.href;
  }

  /**
   * Creates an instance of FooterModuleJS.
   * @param {options} options // options
   * @param {context} context // context
   * @memberof FooterModuleJS
   * @return {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.target = this.settings.target;
    if (spaParams.siteParams.jsTimer) {
      benchmarkUtility.init(this);
    }
  }

  /**
   * Initializes the module
   * @testExample init()
   * @testOutput equal undefined
   * @returns {void}
   */
  init() {
    // Hide Careers link from footer navigation in MDA application
    const wrapUrlParam = (this.SpartaFunctions.getUrlParam('wrap') || '').toUpperCase();
    if (wrapUrlParam === 'MDA') {
      const careersParent = this.target.querySelector('#footer_bofa_careers').parentNode;
      if (careersParent) {
        careersParent.classList.add('mda-hide');
      }
    }
    this.updatePatentURL();

    // on click of "Feedback" link, trigger Medallia code
    const feedbackLink = this.target.querySelector('#footer_bofa_feedback');
    if (feedbackLink) {
      feedbackLink.addEventListener('click', e => {
        e.preventDefault();
        try {
          // eslint-disable-next-line no-undef
          bactm.plugins.feedback.launch();
          // eslint-disable-next-line no-shadow
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      });
    }
  }

  /**
   * @return {void}
   */
  updatePatentURL() {
    const {
      currentURL
    } = this;
    const env = currentURL.split('-')[1];
    let patentURL = '';
    if (currentURL.includes('helix')) {
      patentURL = `https://www-${env}-helix.ecnp.bankofamerica.com/company/patents/`;
    } else {
      patentURL = 'https://patents.bankofamerica.com';
    }
    const patentEl = document.querySelector('#footerPatent');
    if (patentEl !== null) {
      /* Changed for ADSF Scan */
      /* eslint-disable-next-line no-param-reassign */
      patentEl.href = patentURL;
    }
  }
}
registerModuleClass({
  moduleClass: FooterModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { FooterModuleJS as default, moduleConfig };
